import React from 'react';
import { useIsOfflineShellMode } from '../hooks/useMobileMode';
import OfflinePunchDrawerManager from './OfflinePunchDrawerManager';

export default function OfflinePunchDrawerGate() {
  const { isOfflineShellMode } = useIsOfflineShellMode();

  if (!isOfflineShellMode) {
    return null;
  }

  return <OfflinePunchDrawerManager id="webclock-offline-punches" />;
}
